import { Component } from '@angular/core';

import { SportListBodyComponent } from '@frontend/sports/sport-list/feature/sport-list-body';

import { providePromotionsMapIntegration } from '../crm-promotion/promotions-map-integration.provider';

@Component({
    imports: [SportListBodyComponent],
    selector: 'ms-product-menu-sport-list',
    template: `<ms-sport-list-body />`,
    viewProviders: [providePromotionsMapIntegration()],
})
export class ProductMenuSportListComponent {}
